export const removeCity = (facilityName?: string, city?: string) => {
  const safeFacilityName = facilityName || "";
  const safeCity = city || "";

  if (!safeFacilityName || !safeCity) {
    return safeFacilityName;
  }

  const split = safeCity.split(", ");
  const cityName = split[0] || "";
  const stateName = split[1] || "";

  if (!cityName) {
    return safeFacilityName;
  }

  const str1 = `-${cityName}${stateName ? ` ${stateName}` : ""}`;
  if (safeFacilityName.endsWith(str1)) {
    return safeFacilityName.replace(str1, "");
  }

  const str2 = `-${cityName}`;

  if (safeFacilityName.endsWith(str2)) {
    return safeFacilityName.replace(str2, "");
  }

  return safeFacilityName;
};
